const initialState = {
  countsByEventId: {},
  vehiclesRefreshKeyByEventId: {},
};

export default function towingReducer(state = initialState, action) {
  switch (action.type) {
    case 'FETCH_TOWING_COUNT_SUCCESS':
      return {
        ...state,
        countsByEventId: {
          ...state.countsByEventId,
          [action.eventId]: action.payload,
        },
      };
    case 'REFRESH_EVENT_VEHICLES':
      return {
        ...state,
        vehiclesRefreshKeyByEventId: {
          ...state.vehiclesRefreshKeyByEventId,
          [action.eventId]: (state.vehiclesRefreshKeyByEventId[action.eventId] || 0) + 1,
        },
      };

    default:
      return state;
  }
}
